<template>
  <div class="units-select" v-if="selectedUnit">
    <div class="units-select__select" @click="showList = !showList">
      <div
        v-if="getLogoSource(selectedUnit.product.code)"
        class="units-select__select_logo"
        :style="{
          background: `url('${getLogoSource(selectedUnit.product.code)}')`,
          backgroundSize: 'contain',
        }"
      />
      <div class="units-select__select__selected">
        <p>{{ selectedUnit.product.title }}</p>
        <p v-if="isSyndic" class="units-select__unit-info"></p>
        <p v-else class="units-select__unit-info">
          {{ selectedUnit.block.title }} - Unidade
          {{ selectedUnit.unitCodeClean }}
        </p>
      </div>
      <div
        :style="{ height: showList ? 'auto' : '0' }"
        :class="`units-select__select__list no-print ${
          showList ? '--top-arrow' : ''
        }`"
      >
        <div
          v-for="(unitObj, i) in validUnits"
          :key="i"
          :style="{
            display: showList ? 'flex' : 'none',
            fontWeight:
              unitObj.unit.id === selectedUnit.unit.id ? '500' : '400',
            backgroundColor:
              unitObj.unit.id === selectedUnit.unit.id
                ? '#f8f5f5'
                : 'transparent',
          }"
          @click="selectUnit(unitObj)"
          class="units-select__select__list__item"
        >
          <div
            v-if="getLogoSource(unitObj.product.code)"
            class="units-select__select_logo"
            :style="{
              background: `url('${getLogoSource(unitObj.product.code)}')`,
              backgroundSize: 'contain',
            }"
          />
          <div style="margin: 10px">
            <p>{{ unitObj.product.title }}</p>
            <p v-if="isSyndic" class="units-select__unit-info"></p>
            <p v-else class="units-select__unit-info">
              {{ unitObj.block.title }} - Unidade {{ unitObj.unitCodeClean }}
            </p>
          </div>
        </div>
      </div>
      <v-btn
        flat
        :icon="mobile"
        v-if="units.length > 1"
        class="units-select__select__btn no-print"
      >
        <span class="units-select__select__btn__text">
          {{ selectProduct }}
        </span>
        <i
          class="bexsicon-down units-select__select__btn__icon"
          :style="{ transform: showList ? 'rotate(-180deg)' : '' }"
        />
      </v-btn>
    </div>
    <img :src="config.images.brandLogo" class="print-logo" />
  </div>
</template>
<script>
import handlebars from '../../services/handlebars';
import { UNIT, CONFIG, ROLES, IFRAME } from '../../utils/constants';

export default {
  name: 'units-select',
  data() {
    return {
      showList: false,
    };
  },
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    validUnits() {
      if (this.user.userRole === ROLES.CLIENT_ROLE) {
        return this.units.filter(
          (o) => o.contracts[0].id != this.selectedUnit.contracts[0].id
        );
      } else {
        return this.units.filter((o) => o.sku != this.selectedUnit.sku);
      }
    },
    selectProduct() {
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? 'Selecione seu empreendimento'
        : 'Selecione sua unidade';
    },
  },
  created() {
    if (!this.units.length || !this.selectedUnit) {
      this.redirectToUnitSelector();
    }
  },
  methods: {
    redirectToUnitSelector() {
      this.$router.push({ name: 'selectUnit' });
    },
    selectUnit(unitObj) {
      this.$store.dispatch(UNIT.SELECT, unitObj);
    },
    getLogoSource(code) {
      try {
        const data = this.$store.getters[IFRAME.GET_DATA];
        if (!data) {
          return '';
        }

        const mask = data.logoMask;
        if (code) {
          data.code = code;
        }
        const template = handlebars.compile(mask);
        const url = template(data);
        return url;
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.units-select {
  width: 100%;
  height: 75px;
  background-color: #f1eeee;

  @include breakpoint(mobile) {
    height: 100px;
  }

  &__unit-info {
    font-weight: bold;
  }

  &__select {
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;
    position: relative;
    color: var(--light-dark-color);
    display: flex;
    padding: 0.5em;
    align-items: center;
    height: 100%;

    @include breakpoint(mobile) {
      max-width: 100%;
      padding: 1em;
      margin: 0;
    }
    &_logo {
      background-size: contain !important;
      height: 70px;
      width: 70px;
    }

    &__selected {
      padding: 1em;
      flex: 1;
      font-weight: bold;

      @include breakpoint(mobile) {
        flex: 0.9;
      }

      p {
        margin: 0;
      }
    }

    &__btn {
      margin: 0 40%;
      bottom: 0;
      width: 20%;
      position: absolute !important;
      transition: 0.3s all ease;
      padding: 0;
      color: var(--brand-color) !important;
      opacity: 0.75;

      @include breakpoint(mobile) {
        margin: 0;
        right: 35px;
        bottom: 35%;
        width: 30px;
      }

      &__text {
        font-size: 12px;

        @include breakpoint(mobile) {
          display: none;
        }
      }

      &__icon {
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;

        @include breakpoint(mobile) {
          font-size: 21px;
        }
      }
    }

    &__list {
      --list-item-height: 90px;
      height: 0;
      position: absolute;
      width: 100%;
      max-height: calc(3 * var(--list-item-height));
      transition: 300ms all ease;
      background-color: #fff;
      border-radius: 5px;
      z-index: 9999;
      box-shadow: var(--box-shadow);
      top: 100%;
      overflow: auto;
      max-width: 100vw;

      @include breakpoint(mobile) {
        width: 96vw;
        top: 100%;
        left: 2%;
        right: 2%;
        max-height: 90vh;
      }

      &__item {
        height: var(--list-item-height);
        position: relative;
        padding: 1em;
        cursor: pointer;
        color: var(--light-dark-color);

        &:hover {
          background-color: #f8f5f5;
        }

        p {
          margin: 0;
        }
      }
    }

    .--top-arrow {
      &:after {
        bottom: 100%;
        left: 80.5%;
        border: solid transparent;
        content: ' ';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-bottom-color: #fff;
        border-width: 10px;
        margin-left: -10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/unitsSelect/UnitsSelect.vue